import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Matrix4 } from 'math.gl';
import { MVTLoader } from '@loaders.gl/mvt';
import { load } from '@loaders.gl/core';
import { COORDINATE_SYSTEM } from '@deck.gl/core';
import TileLayer from '../tile-layer/tile-layer';
import { getURLFromTemplate } from '../tile-layer/utils';
import ClipExtension from './clip-extension';
var WORLD_SIZE = 512;
var defaultProps = {
  uniqueIdProperty: {
    type: 'string',
    value: ''
  },
  highlightedFeatureId: null
};

var MVTLayer = function (_TileLayer) {
  _inherits(MVTLayer, _TileLayer);

  var _super = _createSuper(MVTLayer);

  function MVTLayer() {
    _classCallCheck(this, MVTLayer);

    return _super.apply(this, arguments);
  }

  _createClass(MVTLayer, [{
    key: "getTileData",
    value: function getTileData(tile) {
      var url = getURLFromTemplate(this.props.data, tile);

      if (!url) {
        return Promise.reject('Invalid URL');
      }

      var options = this.getLoadOptions();
      options = _objectSpread(_objectSpread({}, options), {}, {
        mvt: _objectSpread(_objectSpread({}, options && options.mvt), {}, {
          coordinates: this.context.viewport.resolution ? 'wgs84' : 'local',
          tileIndex: {
            x: tile.x,
            y: tile.y,
            z: tile.z
          }
        })
      });
      return load(url, MVTLoader, options);
    }
  }, {
    key: "renderSubLayers",
    value: function renderSubLayers(props) {
      var tile = props.tile;
      var worldScale = Math.pow(2, tile.z);
      var xScale = WORLD_SIZE / worldScale;
      var yScale = -xScale;
      var xOffset = WORLD_SIZE * tile.x / worldScale;
      var yOffset = WORLD_SIZE * (1 - tile.y / worldScale);
      var modelMatrix = new Matrix4().scale([xScale, yScale, 1]);
      props.autoHighlight = false;

      if (!this.context.viewport.resolution) {
        props.modelMatrix = modelMatrix;
        props.coordinateOrigin = [xOffset, yOffset, 0];
        props.coordinateSystem = COORDINATE_SYSTEM.CARTESIAN;
        props.extensions = [].concat(_toConsumableArray(props.extensions || []), [new ClipExtension()]);
      }

      return _get(_getPrototypeOf(MVTLayer.prototype), "renderSubLayers", this).call(this, props);
    }
  }, {
    key: "onHover",
    value: function onHover(info, pickingEvent) {
      var _this$props = this.props,
          uniqueIdProperty = _this$props.uniqueIdProperty,
          autoHighlight = _this$props.autoHighlight;

      if (autoHighlight) {
        var hoveredFeatureId = this.state.hoveredFeatureId;
        var hoveredFeature = info.object;
        var newHoveredFeatureId;

        if (hoveredFeature) {
          newHoveredFeatureId = getFeatureUniqueId(hoveredFeature, uniqueIdProperty);
        }

        if (hoveredFeatureId !== newHoveredFeatureId) {
          this.setState({
            hoveredFeatureId: newHoveredFeatureId
          });
        }
      }

      return _get(_getPrototypeOf(MVTLayer.prototype), "onHover", this).call(this, info, pickingEvent);
    }
  }, {
    key: "getHighlightedObjectIndex",
    value: function getHighlightedObjectIndex(tile) {
      var hoveredFeatureId = this.state.hoveredFeatureId;
      var _this$props2 = this.props,
          uniqueIdProperty = _this$props2.uniqueIdProperty,
          highlightedFeatureId = _this$props2.highlightedFeatureId;
      var data = tile.data;
      var isFeatureIdPresent = isFeatureIdDefined(hoveredFeatureId) || isFeatureIdDefined(highlightedFeatureId);

      if (!isFeatureIdPresent || !Array.isArray(data)) {
        return -1;
      }

      var featureIdToHighlight = isFeatureIdDefined(highlightedFeatureId) ? highlightedFeatureId : hoveredFeatureId;
      return data.findIndex(function (feature) {
        return getFeatureUniqueId(feature, uniqueIdProperty) === featureIdToHighlight;
      });
    }
  }]);

  return MVTLayer;
}(TileLayer);

export { MVTLayer as default };

function getFeatureUniqueId(feature, uniqueIdProperty) {
  if (uniqueIdProperty) {
    return feature.properties[uniqueIdProperty];
  }

  if ('id' in feature) {
    return feature.id;
  }

  return -1;
}

function isFeatureIdDefined(value) {
  return value !== undefined && value !== null && value !== '';
}

MVTLayer.layerName = 'MVTLayer';
MVTLayer.defaultProps = defaultProps;
//# sourceMappingURL=mvt-layer.js.map